import { Link } from "react-router-dom";
import Accordion from "../../utils/accordion";

export default function NavBar(){
    return (
        <>
            <div className="flex flex-row justify-between md:justify-normal md:flex-col md:fixed md:inset-y-0 md:left-0 md:w-[150px] bg-gray-800 text-white p-4">                
                    <Accordion 
                        titulo={<div className="font-semibold">Articulos</div>}
                        opciones={
                            <ul>
                                <Link to="/informesArticulos">
                                    <li>Listado</li>
                                </Link>
                                <Link to="/articuloNuevo">
                                    <li>Nuevo</li>
                                </Link>
                            </ul>
                        }
                    />                
                <Accordion 
                        titulo={<div className="font-semibold">Clientes</div>}
                        opciones={
                            <ul>
                                <Link to="/informesClientes">
                                    <li>Listado</li>
                                </Link>
                                <Link to="/clienteNuevo">
                                    <li>Nuevo</li>
                                </Link>
                            </ul>
                        }
                    />                
                <Accordion 
                        titulo={<div className="font-semibold">Documentos</div>}
                        opciones={
                            <ul>
                                <Link to="/informesDocumentos">
                                    <li>Listado</li>
                                </Link>
                                <Link to="/documentoNuevo">
                                    <li>Nuevo</li>
                                </Link>
                                <Link to="/rotulos">
                                    <li>Rotulos</li>
                                </Link>
                            </ul>
                        }
                    />                
                <Link to="/calendario">
                        <div className="font-semibold">
                            Calendario
                        </div>
                    </Link>
                <Accordion 
                        titulo={<div className="font-semibold">Ventas</div>}
                        opciones={
                            <ul>
                                <Link to="/ventasGenerales">
                                    <li>Generales</li>
                                </Link>                                
                            </ul>
                        }
                    />  
            </div>
        </>
    )
}